import {
  STATUS_OK } from '../constants/reponseTypes';
import { REGISTRATION_URL } from '../constants/restURLs';
import { fetchApi } from '../api';
import { push } from 'react-router-redux'
import { ACTIVATION_ACCOUNT,
         SAVE_ACCOUNT_ID} from '../constants/actionTypes'
import { getSettings} from './settingActions'
import { getBalanceAccount } from './infoAccountActions'
import { alertFailed, alertSuccess } from './AlertActions';
import { showLoadingIndicator } from './loginActions';

export function register(phoneNum, email, password) {
  return function (dispatch) {
    dispatch( showLoadingIndicator(true) );
    let lang = localStorage.getItem('lang');
    let params = "phonenr=" + phoneNum
                + "&email=" + email
                + "&password=" + password
                + "&lgeCode=" + lang;

    console.log("params", params);
    let callbacks = {
      onSuccess: (response) => {
        console.log('sign up response', response);
        if ( response.status == STATUS_OK ){
            let accountId = response.accountId;
            localStorage.setItem('accountId', accountId);
            dispatch( saveAccountId(accountId) );
            dispatch( getBalanceAccount(accountId) );
            dispatch( getSettings(accountId) );
            dispatch( push('/settings') );
        }else {
          dispatch( alertSuccess(response.message) );
        }
        dispatch( showLoadingIndicator(false) );
      },
      onFailed: (response, statusCode) => {
        dispatch( alertFailed(response.message) );
        dispatch( showLoadingIndicator(false) );
      },
      onError: (error) => {
        dispatch( alertFailed(error) );
        dispatch( showLoadingIndicator(false) );
      }
    }
    fetchApi(dispatch, REGISTRATION_URL, params, callbacks);
    /*setTimeout(function(){
      //
      dispatch( alertFailed("test error") );
      dispatch( showLoadingIndicator(false) );
    }, 5000);*/
  };
}

export const activationAccount = (needActivation) => {
  return {
    type: ACTIVATION_ACCOUNT,
    needActivation: needActivation
  }
}

export const saveAccountId = (accountId) => {
  return {
    type: SAVE_ACCOUNT_ID,
    accountId: accountId
  }
}



// WEBPACK FOOTER //
// ./src/actions/signUpActions.js